import { Component } from "react"
import PropTypes from "prop-types"

import { del, post } from "../../../shared/lib/api"

import Modal from "../../../shared/components/modal"
import Form from "../../../app/components/sdk/form"

import "./clone_delete.scss"

export default class CloneDelete extends Component {
  state = {
    tool: "",
    modalOpen: false,
    deleteConfirmValue: "",
    submitting: false,
  }

  confirmClone = e => {
    e.preventDefault()
    this.setState({
      tool: "clone",
      modalOpen: true,
    })
  }

  confirmDelete = e => {
    e.preventDefault()
    this.setState(
      {
        tool: "delete",
        modalOpen: true,
      },
      () => this.deleteConfirmationInputRef.focus()
    )
  }

  handleClone = e => {
    e.preventDefault()
    this.setState({ submitting: true })
    post(`${this.props.servicePath}/clone`)
      .then(response => {
        window.App.Scripts.partners.displayFlash("Successfully cloned service")
        this.setState({ modalOpen: false })
      })
      .catch(e => {
        this.setState({
          modalOpen: false,
          submitting: false,
        })
        window.App.Scripts.partners.displayFlash(
          "Failed to clone service",
          "error"
        )
      })
  }

  handleDelete = e => {
    e.preventDefault()
    this.setState({ submitting: true })
    del(this.props.servicePath)
      .then(response => {
        window.App.Scripts.partners.displayFlash("Successfully deleted service")
        this.setState({ modalOpen: false })
      })
      .catch(e => {
        this.setState({
          modalOpen: false,
          submitting: false,
        })
        window.App.Scripts.partners.displayFlash(
          "Failed to delete service",
          "error"
        )
      })
  }

  onClose = e => {
    this.setState({ modalOpen: false })
  }

  updateDeleteConfirmValue = e => {
    this.setState({ deleteConfirmValue: e.target.value })
  }

  renderCloneDialogue() {
    return (
      <Modal
        show={this.state.modalOpen}
        closeListener={this.onClose}
        headerText={"Are you sure you want to clone this service?"}
        includeCloseX={false}
      >
        <div className="action-buttons-container">
          <button
            type="submit"
            onClick={this.handleClone}
            className="button-secondary"
            disabled={this.state.submitting}
          >
            {this.state.submitting ? "Cloning..." : "Yes, clone this service"}
          </button>
          <button
            className="button-secondary button-cancel-link"
            onClick={this.onClose}
          >
            Cancel
          </button>
        </div>
      </Modal>
    )
  }

  renderDeleteDialogue() {
    const disabled =
      this.state.submitting ||
      this.state.deleteConfirmValue !== this.props.serviceSlug
    return (
      <Modal
        show={this.state.modalOpen}
        closeListener={this.onClose}
        headerText={"Are you sure you want to delete this service?"}
        includeCloseX={false}
      >
        <Form onSubmit={this.handleDelete} disabled={disabled}>
          <p>{`Type this service's slug (${this.props.serviceSlug}) to confirm`}</p>
          <input
            ref={ref => (this.deleteConfirmationInputRef = ref)}
            styleName="delete-confirmation"
            type="text"
            value={this.state.deleteConfirmValue}
            onChange={this.updateDeleteConfirmValue}
          />
          <div className="action-buttons-container">
            <button
              type="submit"
              onClick={this.handleDelete}
              className="button-secondary"
              disabled={disabled}
            >
              {this.state.submitting
                ? "Deleting..."
                : "Yes, delete this service"}
            </button>
            <button
              className="button-secondary button-cancel-link"
              onClick={this.onClose}
            >
              Cancel
            </button>
          </div>
        </Form>
      </Modal>
    )
  }

  render() {
    return (
      <div className="form">
        <section className="form-section">
          <div className="label">Clone service</div>
          <p>
            This creates a new unpublished clone of this service. It can be used
            for staging, experiments, or further development.
          </p>
          <a href="#" onClick={this.confirmClone} className="button-tertiary">
            Clone service
          </a>
        </section>

        <section className="form-section">
          <div className="label">Delete service</div>
          <p>
            This will delete the service. A service may only be deleted if it is
            unpublished and has no more than 100 users. This action can{" "}
            <b>not</b> be undone.
          </p>
          <a href="#" onClick={this.confirmDelete} className="button-tertiary">
            Delete service
          </a>
        </section>

        {this.state.tool === "clone"
          ? this.renderCloneDialogue()
          : this.renderDeleteDialogue()}
      </div>
    )
  }
}
